export default "__VITE_ASSET__000a8634__"